<div *ngIf="spinner==true">
  <ngx-spinner size="medium" type="timer">
    <p style="font-size: 20px; color: white;padding-left:7%;">Loading...</p>
  </ngx-spinner>
</div>
<div class="container-fluid">
  <div class="card shadow">
     <div class="card-header">
          <div class="d-flex justify-content-between">
            <h4  class="font-weight-bold text-dark py">DISTRICT-WISE ENROLLMENT REPORT</h4>
            <!-- <button (click)="printTable()">Print DataTable</button> -->
          </div>
         
      </div>
   
      <!-- DISTRICT ADMIN DATATABLE         -->
      <div class="wrapper" >
       
        <div class="card-body">
            <div class="table-responsive" *ngIf="tableshow">
                <!-- TABLE -->
             
                <table class="table table-bordered display" [dtOptions]="dtOptions" datatable width="100%"
                    cellspacing="0" #dataTable>
                  
                    <thead>
                        <tr>
                          <th>District</th>
                            <th>District Admin Name</th>
                            <th>Mobile Number</th>
                            <!-- <th>Status</th> -->
                            <th>No. of Office Bearer</th>                            

                        </tr>
                    </thead>

                    <tbody>
                        <tr *ngFor="let customer of customers[0]">
                          <td style="min-width: 20px;">
                            {{customer.district}}
                        </td>
                            <td style="min-width: 20px;">
                                {{customer.name}}
                            </td>                            
                            <!-- <td style="min-width: 20px;">
                                {{customer.approval_status}}
                            </td> -->
                            <td style="min-width: 20px;">
                              {{customer.contact_no}}
                            </td>
                            <td style="min-width: 20px;">
                              <strong>{{customer.regob}}</strong>
                            </td>
                           
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        </div>
      </div>
    </div>
